import { useExperiments } from '@wix/yoshi-flow-editor';
import type { FC } from 'react';
import React from 'react';

import { Experiment } from '../../../../../constants/experiments';
import type { BaseComponentProps } from '../../../../../types';
import { DataHook } from '../../../../../types';
import { Loader } from './common';
import { Content } from './Content';
import { Cover } from './Cover';
import styles from './DesktopResponsiveWidget.scss';

const DesktopResponsiveWidget: FC<BaseComponentProps> = ({ profilePage }) => {
  const { experiments } = useExperiments();
  const { isSaving, isCoverRepositionMode } = profilePage;

  const removeContainerMinWidth = experiments.enabled(
    Experiment.RemoveProfileCardContainerMinWidth,
  );

  const containerClassName = removeContainerMinWidth
    ? undefined
    : styles.profile;

  return (
    <div data-hook={DataHook.HorizontalWidget} className={styles.box}>
      <div className={containerClassName}>
        {isSaving && <Loader />}
        <Cover />
        {!isCoverRepositionMode && <Content />}
      </div>
    </div>
  );
};

export default DesktopResponsiveWidget;
